"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMultiFilterButtons = void 0;
const React = __importStar(require("react"));
const index_1 = require("../../../index");
const Button_1 = __importDefault(require("../../Button/Button"));
const SearchMultiFilterButtons = ({ filters, handleFilter, selectedFilters }) => {
    return (React.createElement("div", { className: "multi-filter-group" }, filters.map((filter, index) => createButton(filter, index))));
    function createButton(filter, index) {
        return (React.createElement(Button_1.default, { key: 'multi-filter-' + index, color: !!(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.find((selectedFilter) => selectedFilter.key === filter.key)) ? 'filter-selected' : 'filter', onClick: () => handleFilter(filter) },
            React.createElement(index_1.Icon, { icon: !!(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.find((selectedFilter) => selectedFilter.key === filter.key)) ? 'check' : 'plus' }),
            React.createElement("div", { className: "filter-title" }, filter.title)));
    }
};
exports.SearchMultiFilterButtons = SearchMultiFilterButtons;
//# sourceMappingURL=SearchMultiFilterButtons.js.map